import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGameConfig } from '../context/GameConfigContext';
import './TestPhaseBanner.css';

// Ekranın en üstünde küçük "test aşaması" uyarısı.
const TestPhaseBanner = () => {
  const { t } = useTranslation('common');
  const { gelistirmeConsole } = useGameConfig();
  return (
    <div className={`test-phase-banner${gelistirmeConsole ? ' test-phase-banner--below-dev' : ''}`} role="note">
      {t('testPhaseNotice')}
    </div>
  );
};

export default TestPhaseBanner;
